import config from '@/config'
import { requests } from './HTTPService'

const http = requests(config?.COMMUNITIES_SERVER_URL)

export default class GiphyService {
  protected basePath = ''
  constructor() {
    this.basePath = `giphy/gifs`
  }

  async fetchTrendingGifs(
    limit: number,
    offset: number,
    rating = 'pg-13',
    language = 'en'
  ): Promise<any> {
    return http
      .get(`${this.basePath}`, {
        params: {
          searchText: 'hello',
          limit,
          offset,
          rating,
          language,
        },
      })
      .then(res => res.data)
  }

  async fetchGifs(
    searchText: string,
    limit: number,
    offset: number,
    rating = 'pg-13',
    language = 'en'
  ): Promise<any> {
    return http
      .get(`${this.basePath}`, {
        params: {
          searchText,
          limit,
          offset,
          rating,
          language,
        },
      })
      .then(res => res.data)
  }
}
